import { render, staticRenderFns } from "./ModalSuccess.vue?vue&type=template&id=e2b27294&scoped=true&"
import script from "./ModalSuccess.vue?vue&type=script&lang=js&"
export * from "./ModalSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuccess.vue?vue&type=style&index=0&id=e2b27294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b27294",
  null
  
)

export default component.exports